/**
 * Inactivity sign-out policy.
 *
 * A signed-in browser that has seen no real USER activity (pointer, key,
 * touch, wheel, returning focus) in ANY OptiBay tab for this long is signed
 * out. Background network, token refresh, realtime, polling and timers never
 * count. This is inactivity, not an absolute session lifetime.
 *
 * Founder decision (2026-10-05): 3 hours, adjustable within 2–4 hours.
 * Change IDLE_SIGN_OUT_MINUTES only; values outside the range are clamped.
 */
export const IDLE_SIGN_OUT_MINUTES = 180;
export const IDLE_SIGN_OUT_MIN_MINUTES = 120;
export const IDLE_SIGN_OUT_MAX_MINUTES = 240;

/** How long before sign-out the "still there?" warning appears. */
export const IDLE_WARNING_MINUTES = 5;

/** How often each tab re-evaluates (also on focus / visibility return). */
export const IDLE_CHECK_INTERVAL_MS = 30_000;

/** Activity is shared across tabs through localStorage, written at most this often. */
export const IDLE_ACTIVITY_WRITE_THROTTLE_MS = 15_000;

/** localStorage key: { at: epoch ms of the last real activity, sid: the auth session it belongs to }. */
export const IDLE_ACTIVITY_STORAGE_KEY = 'optibay:lastActivityAt';

export function idleTimeoutMs(minutes: number = IDLE_SIGN_OUT_MINUTES): number {
  const m = Number.isFinite(minutes) ? minutes : IDLE_SIGN_OUT_MINUTES;
  return Math.min(Math.max(m, IDLE_SIGN_OUT_MIN_MINUTES), IDLE_SIGN_OUT_MAX_MINUTES) * 60_000;
}
